import { types } from 'mobx-state-tree'

import storeWithFlags from '../../../../../../utils/storeWithFlags'
import chatConversation from '../../../../../../models/chatConversation'
import user from '../../../../../../models/user'

const store = types
	.model({
		conversations: types.array(chatConversation),
		newChatEmailFieldValue: types.maybe(types.string),
		newChatEmailFieldSelectedEmails: types.array(types.string),
		newChatAvailableUsers: types.array(user)
	})
	.actions(self => ({
		setNewChatAvailableUsers(users: any) {
			self.newChatAvailableUsers = users
		},
		setNewChatEmailFieldSelectedEmails(emails: any) {
			self.newChatEmailFieldSelectedEmails = emails
		},
		setNewChatEmailFieldValue(value: any) {
			self.newChatEmailFieldValue = value
		},
		setConversations(conversations: any) {
			self.conversations = conversations
		}
	}))

export default types
	.compose(
		storeWithFlags,
		store
	)
	.create({})